export default {
  placeholder: 'Ninguno',
};
